var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.583 8.86a.75.75 0 1 0-1.166.943c.468.58 1.05 1.206 1.752 1.807L2.34 14.78a.75.75 0 1 0 1.3.75l1.734-3.006a11.7 11.7 0 0 0 3.303 1.527l-.545 3.094a.75.75 0 0 0 1.477.26l.536-3.039c.587.087 1.205.135 1.855.135q.97-.002 1.847-.134l.536 3.04a.75.75 0 1 0 1.477-.26l-.545-3.093a11.7 11.7 0 0 0 3.307-1.527l1.725 2.988a.75.75 0 0 0 1.299-.75l-1.819-3.15a13.8 13.8 0 0 0 1.756-1.81.75.75 0 0 0-1.166-.943 12 12 0 0 1-2.039 1.997C16.836 12.038 14.74 13 12 13c-2.741 0-4.839-.963-6.382-2.145l-.044-.034a12 12 0 0 1-1.99-1.96",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOff;